// View
import Form from '@views/Form'
import ClaimInformationRequest from '@components/ClaimInformationRequest'

const config: Page.Config = {
  title: 'Submission Additional Details',
  dataset: ['submission'],
  view: ClaimInformationRequest,
}

export default config
